import ArrowRightIcon from "../icons/ArrowRightIcon";
import styled from "styled-components";
interface CTALinkProps {
  arrow?: "pre" | "post";
}
const CTALink = styled('span').withConfig({
  shouldForwardProp: (prop) => !['arrow'].includes(prop)
})<CTALinkProps>`
  font-weight: bold;
  color: #de4a22;
  svg {
    background-color: #de4a22;
    border-radius: 50%;
    padding: 0em 0em 0em 0.3em;
    vertical-align: middle;
    margin-top: -0.1em;
    ${({ arrow }) =>
      arrow === "post" ? `margin-left: 0.3em;` : `margin-right: 0.3em;`}
  }
`;

const ArrowLink = ({ children, arrow,...other }: any) => (
  <CTALink arrow={arrow}{...other}>
    {arrow !== "post" && <ArrowRightIcon />}
    {children}
    {arrow === "post" && <ArrowRightIcon />}
  </CTALink>
);
export default ArrowLink;
